import React from 'react';
import { WebsiteDesignProps } from './types';
import { Flag, Gauge, Timer, Trophy } from 'lucide-react';
import { Button } from "@/components/ui/button";

const RacingTeam: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Velocity High";

    return (
        <div className="bg-white text-black min-h-screen font-sans italic selection:bg-red-600 selection:text-white overflow-hidden">
            {/* Checkered Flag Pattern Stripe */}
            <div className="h-4 w-full" style={{backgroundImage: 'repeating-linear-gradient(45deg, #000 25%, transparent 25%, transparent 75%, #000 75%, #000), repeating-linear-gradient(45deg, #000 25%, #fff 25%, #fff 75%, #000 75%, #000)', backgroundPosition: '0 0, 10px 10px', backgroundSize: '20px 20px'}}></div>

            <nav className="p-6 flex justify-between items-center bg-[#111] text-white skew-y-[-2deg] origin-top shadow-xl relative z-20 mt-4 mx-4 border-l-8 border-red-600">
                <div className="text-3xl font-black uppercase tracking-tighter italic pl-4">
                    {schoolName} <span className="text-red-600">Racing</span>
                </div>
                <div className="flex gap-4 pr-4">
                     <Button className="bg-red-600 hover:bg-red-700 text-white font-black uppercase italic rounded skew-x-[-10deg] px-8 border-2 border-white">
                         Ticket
                     </Button>
                </div>
            </nav>

            <main className="container mx-auto px-6 py-20 relative z-10">
                 {/* Speed Lines Background */}
                 <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" style={{background: 'linear-gradient(90deg, transparent 50%, #000 50%)', backgroundSize: '4px 100%'}}></div>

                 <div className="flex flex-col md:flex-row items-center gap-12">
                     <div className="md:w-1/2">
                         <div className="inline-block bg-black text-white px-4 py-1 font-black uppercase italic text-sm mb-4 skew-x-[-10deg]">
                             Season 2026
                         </div>
                         <h1 className="text-7xl md:text-9xl font-black uppercase italic mb-6 leading-[0.8]">
                             Full <br/> <span className="text-red-600">Throttle.</span>
                         </h1>
                         <p className="text-xl font-bold uppercase text-gray-800 mb-8 max-w-md italic border-l-4 border-black pl-4">
                             Accelerate your learning curve. We train the champions of the track and the classroom.
                         </p>
                         <div className="flex gap-4">
                             <Button className="h-16 bg-black text-white hover:bg-gray-800 text-xl font-black uppercase italic skew-x-[-10deg] px-10 shadow-[4px_4px_0_#ef4444]">
                                 Start Engine
                             </Button>
                         </div>
                     </div>
                     <div className="md:w-1/2 relative bg-gray-100 skew-x-[-10deg] border-4 border-black p-2 shadow-[8px_8px_0_black]">
                         <img src="https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=2070&auto=format&fit=crop" className="w-full h-64 md:h-96 object-cover grayscale contrast-125 skew-x-[10deg]" alt="Car" />
                         <div className="absolute top-4 right-4 bg-red-600 text-white font-black p-2 text-2xl border-2 border-white skew-x-[10deg]">
                             P1
                         </div>
                     </div>
                 </div>

                 <div className="mt-24 grid grid-cols-1 md:grid-cols-4 gap-4">
                     {[
                         { icon: Gauge, label: "Performance" },
                         { icon: Timer, label: "Efficiency" },
                         { icon: Flag, label: "Victory" },
                         { icon: Trophy, label: "Legacy" }
                     ].map((item, i) => (
                         <div key={i} className="bg-black text-white p-6 skew-x-[-10deg] border-b-4 border-red-600 hover:bg-red-600 transition-colors cursor-pointer group">
                             <item.icon size={32} className="mb-2 skew-x-[10deg] group-hover:scale-110 transition-transform" />
                             <h3 className="font-black uppercase italic skew-x-[10deg] text-xl">{item.label}</h3>
                         </div>
                     ))}
                 </div>
            </main>
        </div>
    );
};

export default RacingTeam;
